import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';

export default function BannerCard({ banner, onEdit, onDelete, onToggleEnabled }) {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id: banner._id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
  };

  return (
    <div
      ref={setNodeRef}
      style={style}
      className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden hover:shadow-md transition-shadow"
    >
      <div className="flex items-center gap-4 p-4">
        {/* Drag Handle */}
        <div
          {...attributes}
          {...listeners}
          className="cursor-grab active:cursor-grabbing text-gray-400 hover:text-gray-600 transition-colors"
        >
          <i className="ri-draggable text-2xl"></i>
        </div>

        {/* Banner Preview */}
        <div className="w-48 h-20 rounded-lg overflow-hidden bg-gray-100 flex-shrink-0">
          <img
            src={banner.image}
            alt={banner.title}
            className="w-full h-full object-cover"
          />
        </div>

        {/* Banner Info */}
        <div className="flex-1 min-w-0">
          <h3 className="text-lg font-semibold text-gray-900 truncate">{banner.title}</h3>
          <p className="text-sm text-gray-500">Order: {banner.order}</p>
        </div>

        {/* Status Toggle */}
        <div className="flex items-center gap-2">
          <span className="text-sm text-gray-600 whitespace-nowrap">
            {banner.isActive  ? 'Active' : 'Hidden'}
          </span>
          <button
            onClick={() => onToggleEnabled(banner)}
            className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors cursor-pointer ${
              banner.isActive ? 'bg-pink-500' : 'bg-gray-300'
            }`}
          >
            <span
              className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${
                banner.isActive ? 'translate-x-6' : 'translate-x-1'
              }`}
            />
          </button>
        </div>

        {/* Actions */}
        <div className="flex items-center gap-2">
          <button
            onClick={onEdit}
            className="p-2 text-gray-600 hover:text-pink-500 hover:bg-pink-50 rounded-lg transition-colors cursor-pointer"
            title="Edit banner"
          >
            <i className="ri-edit-line text-xl"></i>
          </button>
          <button
            onClick={onDelete}
            className="p-2 text-gray-600 hover:text-red-500 hover:bg-red-50 rounded-lg transition-colors cursor-pointer"
            title="Delete banner"
          >
            <i className="ri-delete-bin-line text-xl"></i>
          </button>
        </div>
      </div>
    </div>
  );
}
